import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'ldw-link-error-dialog',
    templateUrl: './link-error-dialog.component.html',
    styleUrls: ['./link-error-dialog.component.css'],
    standalone: false
})
export class LinkErrorDialogComponent {
  dialogRef = inject<MatDialogRef<LinkErrorDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  title!: string;
  message!: string;
  linktext!: string;

  constructor() {
    const data = this.data;

    this.title = this.linktext = data.linktext ?? '';
    this.linktext = data.linktext ?? '';
  }
}
